import { render } from "./TowerOfProduction.vue?vue&type=template&id=9bbc9b08&scoped=true"
import script from "./TowerOfProduction.vue?vue&type=script&lang=js"
export * from "./TowerOfProduction.vue?vue&type=script&lang=js"

import "./TowerOfProduction.vue?vue&type=style&index=0&id=9bbc9b08&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bbc9b08"]])

export default __exports__